import React from "react";
import { Card, Typography, Row, Col } from "antd";
import { TagsOutlined } from "@ant-design/icons";
// Define the props interface
type TProps = {
  cardTitle: string;
  service: number;
  install: number;
  other: number;
};

const DashboardCardComponent: React.FC<TProps> = ({
  cardTitle,
  service,
  install,
  other,
}) => {
  return (
    <Card
      style={{
        height: 132,
        // width: "95%",
        // margin: "0 10px",
        textAlign: "left",
        border: `1px solid var(--bs-primary)`,
        borderRadius: 1,
        background: "var(--bs-primary)",
        color: "#FFF",
        alignContent: "center",
      }}
    >
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <TagsOutlined style={{ fontSize: "3rem" }} />
        </div>
        <div
          style={{
            marginLeft: "20px",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div>
            <Typography.Text
              style={{
                display: "block",
                marginTop: 5,
              }}
            >
              <strong
                style={{
                  fontFamily: "Montserrat-SemiBold !important",
                  color: "#FFF",
                  fontSize: 16,
                }}
              >
                {cardTitle}
              </strong>
            </Typography.Text>

            {/* Second Row - Service, Install, and Others */}
            <Row gutter={16} style={{ marginTop: 2 }}>
              <Col span={8}>
                {/* <Typography.Text style={{ color: "#FFF" }}>Service</Typography.Text> */}
                <div style={{ fontSize: 26, color: "#FFF" }}>
                  {service + install + other}
                </div>
              </Col>
            </Row>
          </div>
          <div>
            <Typography.Text
              style={{
                display: "block",
                marginTop: 5,
              }}
            >
              <strong
                style={{
                  fontFamily: "Montserrat-SemiBold !important",
                  color: "#FFF",
                  fontSize: 16,
                }}
              >
                Service
              </strong>
            </Typography.Text>

            {/* Second Row - Service, Install, and Others */}
            <Row gutter={16} style={{ marginTop: 2 }}>
              <Col span={8}>
                {/* <Typography.Text style={{ color: "#FFF" }}>Service</Typography.Text> */}
                <div style={{ fontSize: 26, color: "#FFF" }}>{service}</div>
              </Col>
            </Row>
          </div>
          <div>
            <Typography.Text
              style={{
                display: "block",
                marginTop: 5,
              }}
            >
              <strong
                style={{
                  fontFamily: "Montserrat-SemiBold !important",
                  color: "#FFF",
                  fontSize: 16,
                }}
              >
                Install
              </strong>
            </Typography.Text>

            {/* Second Row - Service, Install, and Others */}
            <Row gutter={16} style={{ marginTop: 2 }}>
              <Col span={8}>
                {/* <Typography.Text style={{ color: "#FFF" }}>Service</Typography.Text> */}
                <div style={{ fontSize: 26, color: "#FFF" }}>{install}</div>
              </Col>
            </Row>
          </div>
          <div>
            <Typography.Text
              style={{
                display: "block",
                marginTop: 5,
              }}
            >
              <strong
                style={{
                  fontFamily: "Montserrat-SemiBold !important",
                  color: "#FFF",
                  fontSize: 16,
                }}
              >
                Other
              </strong>
            </Typography.Text>

            {/* Second Row - Service, Install, and Others */}
            <Row gutter={16} style={{ marginTop: 2 }}>
              <Col span={8}>
                {/* <Typography.Text style={{ color: "#FFF" }}>Service</Typography.Text> */}
                <div style={{ fontSize: 26, color: "#FFF" }}>{other}</div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Card Title (First Row) */}
    </Card>
  );
};

export default DashboardCardComponent;
